// Matrimonial.jsx
import { Link } from 'react-router-dom'
import s from './styles.module.scss'
import { Encrypt } from 'helpers'
import { Modal } from 'components'

export default function Matrimonial({ matrimonialData = [], deleteHandler }) {
    // Matrimonial data logged for debugging (removed for security)
  return (
    <div className={s.main}>
      <div className={s.table}>
        <div className={s.tableHeading}>
          <div className={s.srNo}>S.No.</div>
          <div className={s.name}>Name</div>
          <div className={s.age}>Age</div>
          <div className={s.gender}>Gender</div>
          <div className={s.city}>City</div>
          <div className={s.status}>Status</div>
          <div className={s.actions}>Actions</div>
        </div>
        <div className={s.tableBody}>
          {matrimonialData.map(
            (
              {
                _id,
                fullName,
                age,
                gender,
                city,
                approvalStatus,
                rejectionMessage
              },
              i
            ) => (
              <div className={s.tableRowOuter} key={_id}>
                <div
                  className={s.tableRow}
                  style={{
                    border:
                      approvalStatus === 'Rejected'
                        ? '0.1rem solid var(--c-red)'
                        : approvalStatus === 'Pending'
                        ? '0.1rem solid var(--c-primary)'
                        : '',
                    marginTop: approvalStatus !== 'Approved' && '1.5rem',
                    borderTopLeftRadius: approvalStatus !== 'Approved' && '0',
                    borderBottomLeftRadius: rejectionMessage && '0',
                    borderBottomRightRadius: rejectionMessage && '0',
                  }}
                >
                  {approvalStatus !== 'Approved' && (
                    <div
                      className={s.pendingStatus}
                      style={{
                        background:
                          approvalStatus === 'Rejected' && 'var(--c-red)',
                        borderRight: 'none'
                      }}
                    >
                      {approvalStatus}
                    </div>
                  )}
                  <div className={s.srNo}>{i + 1}</div>
                  <div className={s.name}>{fullName}</div>
                  <div className={s.age}>{age}</div>
                  <div className={s.gender}>{gender}</div>
                  <div className={s.city}>{city}</div>
                  <div className={s.status}>{approvalStatus}</div>

                  <div className={s.actions}>
                  <Link
                   to={`/matrimonial/edit/${Encrypt({ id: _id })}`} title='Edit Matrimonial'>
                   <span className='material-icons-outlined'>edit</span>
                  </Link>
                    <div
                      onClick={() =>
                        Modal.Confirm(
                          `Are you sure you want to delete ${fullName}'s profile?`,
                          () => deleteHandler(_id)
                        )
                      }
                      title='Delete Profile'
                    >
                      <span className='material-icons-outlined'>delete</span>
                    </div>
                  </div>
                </div>
                {!!rejectionMessage && (
                  <div className={s.rejectionMessage}>
                    <div className={s.title}>
                      This profile is rejected, please comply with the following
                      and update accordingly.
                    </div>
                    {rejectionMessage}
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
}
